<mat-card *ngIf="showToolsPanel" class="customer-card branding--section-card">
	<mat-card-content>
		<form [formGroup]="toolsForm" class="tools-form dense-component-container">
			<mat-form-field class="poly-search-input" subscriptSizing="dynamic">
				<mat-icon matPrefix (click)="searchOrders($event)">search</mat-icon>
				<input matInput type="text" formControlName="searchControl" placeholder="{{ 'MY_ADS.LIST.TOOLS_SEARCH_CONTROL_LABEL' | translate }}" (keydown.enter)="searchOrders($event)" (keydown.escape)="resetSearch()">
				<button matSuffix mat-icon-button (click)="resetSearch()" *ngIf="searchControl.value" class="clear-button">
					<mat-icon>clear</mat-icon>
				</button>
			</mat-form-field>
			<button mat-stroked-button (click)="searchOrders($event)">{{ 'MY_ADS.LIST.TOOLS_SEARCH_CONTROL_ACTION' | translate }}</button>
			<mat-button-toggle-group #group="matButtonToggleGroup" [multiple]="true" (change)="filterPanelShowHide(group.value)">
				<mat-button-toggle value="filterPanel" [checked]="false">
					<mat-icon>filter_list</mat-icon>
				</mat-button-toggle>
			</mat-button-toggle-group>
		</form>
		<div *ngIf="isFilterPanelActive" class="filter-panel">
			<div class="filter-fields-container" *ngIf="filterDataReady$ | async; else filterLoading">
				<mat-form-field subscriptSizing="dynamic">
					<mat-label>{{ 'MY_ADS.LIST.TOOLS_FILTER_PRODUCTS_CONTROL_LABEL' | translate }}</mat-label>
					<mat-select [(value)]="productFilterValue" (selectionChange)="productFilterValueChanged($event)" [disabled]="!filterPackagesReady">
						<mat-option value="" *ngIf="!filterPackagesReady">{{ 'MY_ADS.LIST.TOOLS_FILTER_PRODUCTS_CONTROL_VALUE_LOADING' | translate }}</mat-option>
						<mat-option value="">{{ 'MY_ADS.LIST.TOOLS_FILTER_PRODUCTS_CONTROL_VALUE_ALL' | translate }}</mat-option>
						<mat-option *ngFor="let packageLabel of packageLabels" value="{{ packageLabel }}">{{ packageLabel }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field subscriptSizing="dynamic">
					<mat-label>{{ 'MY_ADS.LIST.TOOLS_FILTER_CONTACT_CONTROL_LABEL' | translate }}</mat-label>
					<mat-select [(value)]="contactIdFilterValue" (selectionChange)="contactIdFilterValueChanged($event)">
						<mat-option value="">{{ 'MY_ADS.LIST.TOOLS_FILTER_CONTACT_CONTROL_VALUE_ALL' | translate }}</mat-option>
						<mat-option *ngFor="let contact of contacts" value="{{ contact.id }}">{{ contact.displayName }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field subscriptSizing="dynamic">
					<mat-label>{{ 'MY_ADS.LIST.TOOLS_FILTER_STATUS_CONTROL_LABEL' | translate }}</mat-label>
					<mat-select [(value)]="statusFilterValue" (selectionChange)="statusFilterValueChanged($event)">
						<mat-option value="">{{ 'MY_ADS.LIST.TOOLS_FILTER_CONTACT_CONTROL_VALUE_ALL' | translate }}</mat-option>
						<mat-option *ngFor="let status of statuses" value="{{ status }}">{{ status | translate }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field subscriptSizing="dynamic">
					<mat-label>{{ 'MY_ADS.LIST.TOOLS_FILTER_ISSUE_DATE_FROM_LABEL' | translate }}</mat-label>
					<input matInput [matDatepicker]="pickerIssueDateFrom" [ngModel]="issueDateFromFilterValue" (dateChange)="issueDateFromValueChanged($event)" [max]="issueDateToFilterValue" disabled>
					<mat-datepicker-toggle matIconSuffix [for]="pickerIssueDateFrom"></mat-datepicker-toggle>
					<mat-datepicker-toggle matSuffix (click)="clearIssueDateFrom()">
						<mat-icon matDatepickerToggleIcon>clear</mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #pickerIssueDateFrom disabled="false"></mat-datepicker>
				</mat-form-field>
				<mat-form-field subscriptSizing="dynamic">
					<mat-label>{{ 'MY_ADS.LIST.TOOLS_FILTER_ISSUE_DATE_TO_LABEL' | translate }}</mat-label>
					<input matInput [matDatepicker]="pickerIssueDateTo" [ngModel]="issueDateToFilterValue" (dateChange)="issueDateToValueChanged($event)" [min]="issueDateFromFilterValue" disabled>
					<mat-datepicker-toggle matIconSuffix [for]="pickerIssueDateTo"></mat-datepicker-toggle>
					<mat-datepicker-toggle matSuffix (click)="clearIssueDateTo()">
						<mat-icon matDatepickerToggleIcon>clear</mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #pickerIssueDateTo disabled="false"></mat-datepicker>
				</mat-form-field>
			</div>
		</div>
	</mat-card-content>
</mat-card>

<ng-container>
	<mat-expansion-panel *ngFor="let orderHeaderVM of refinedOrderHeadersVMs; let idx = index"
						 class="my-ad-list-order-card list-item-card"
						 [expanded]="forceExpand">
		<mat-expansion-panel-header class="indicator-bottom">
			<div class="card-header">
				<app-order-id-chip [orderID]="orderHeaderVM.id" [description]="orderHeaderVM.campaignName"></app-order-id-chip>
				<div class="customer" *ngIf="showCustomerAndAgency">
					{{ orderHeaderVM.customerName }}
					<ng-container *ngIf="orderHeaderVM.otherPayerName as agencyName">
						&bull; {{ agencyName}}
					</ng-container>
				</div>
				<mat-chip-set class="status-chip-list">
					<mat-basic-chip *ngIf="orderHeaderVM.statusVM.isNew" class="branding--order-status-draft">{{ "ORDER_BASKET.STATUS.NEW" | translate }}</mat-basic-chip>
					<mat-basic-chip *ngIf="orderHeaderVM.statusVM.draft" class="branding--order-status-draft">{{ "ORDER_BASKET.STATUS.DRAFT" | translate }}</mat-basic-chip>
					<mat-basic-chip *ngIf="orderHeaderVM.statusVM.started" class="branding--order-status-started">{{ "ORDER_BASKET.STATUS.STARTED" | translate }}</mat-basic-chip>
					<mat-basic-chip *ngIf="orderHeaderVM.statusVM.finished" class="branding--order-status-finished">{{ "ORDER_BASKET.STATUS.FINISHED" | translate }}</mat-basic-chip>
					<mat-basic-chip *ngIf="orderHeaderVM.statusVM.approvalPendingAdCount > 0" class="branding--order-status-approval-pending">{{ ("ORDER_BASKET.STATUS.APPROVAL_PENDING" | translate) + " x" + orderHeaderVM.statusVM.approvalPendingAdCount }}</mat-basic-chip>
					<mat-basic-chip *ngIf="orderHeaderVM.statusVM.rejectedAdCount > 0" class="branding--order-status-rejected">{{ ("ORDER_BASKET.STATUS.REJECTED" | translate) + " x" + orderHeaderVM.statusVM.rejectedAdCount }}</mat-basic-chip>
					<mat-basic-chip *ngIf="orderHeaderVM.statusVM.reservedAdCount > 0" class="branding--order-status-reserved">{{ ("ORDER_BASKET.STATUS.RESERVED" | translate) + " x" + orderHeaderVM.statusVM.reservedAdCount }}</mat-basic-chip>
					<mat-basic-chip *ngIf="orderHeaderVM.statusVM.confirmedAdCount > 0" class="branding--order-status-confirmed">{{ ("ORDER_BASKET.STATUS.CONFIRMED" | translate) + " x" + orderHeaderVM.statusVM.confirmedAdCount }}</mat-basic-chip>
					<mat-basic-chip *ngIf="orderHeaderVM.statusVM.waitingMaterial" class="branding--order-status-waiting-material">{{ "ORDER_BASKET.STATUS.WAITING_MATERIAL" | translate }}</mat-basic-chip>
					<mat-basic-chip *ngIf="orderHeaderVM.statusVM.cancelled" class="branding--order-status-cancelled">{{ "ORDER_BASKET.STATUS.CANCELLED" | translate }}</mat-basic-chip>
				</mat-chip-set>
				<div class="confirmation-deadline-warning" *ngIf="orderHeaderVM.isConfirmationDeadlineApproaching || orderHeaderVM.isConfirmationDeadlinePassed" [class.confirmation-deadline-approaching]="orderHeaderVM.isConfirmationDeadlineApproaching" [class.confirmation-deadline-passed]="orderHeaderVM.isConfirmationDeadlinePassed">
					<ng-container *ngIf="orderHeaderVM.isConfirmationDeadlineApproaching">
						<mat-icon>access_time</mat-icon>
						<span>&nbsp;{{ "ORDER_BASKET.CONFIRMATION_DEADLINE_WARNING.APPROACHING" | translate }}</span>
					</ng-container>
					<ng-container *ngIf="orderHeaderVM.isConfirmationDeadlinePassed">
						<mat-icon>notifications_active</mat-icon>
						<span>&nbsp;{{ "ORDER_BASKET.CONFIRMATION_DEADLINE_WARNING.PASSED" | translate }}</span>
					</ng-container>
				</div>
			</div>
		</mat-expansion-panel-header>
		<div class="card-content-container">
			<div class="fields-container-group">
				<div class="fields-container" *ngIf="orderHeaderVM.agencyContactId !== '0' && getAgencyContact(orderHeaderVM.otherPayerId, orderHeaderVM.agencyContactId) as agencyContact; else agencyContactIdNull">
					<div class="field">
						<div class="data-panel-field-label">{{ "MY_ADS.LIST.AGENCY_CONTACT" | translate }}</div>
						<div class="data-panel-field-value">{{ agencyContact.firstName + " " + agencyContact.lastName}}</div>
						<div class="data-panel-field-value contact-email" *ngIf="agencyContact.email">
							<a class="branding--general--email-address" href="{{ 'mailto:' + agencyContact.email }}"><span class="contact-email-icon">email</span> {{ agencyContact.email }}</a>
						</div>
						<div class="data-panel-field-value contact-phone" *ngIf="agencyContact.phone">
							<p class="branding--general--phone"><span class="contact-phone-icon">phone</span> {{ agencyContact.phone }}</p>
						</div>
					</div>
				</div>
				<ng-template #agencyContactIdNull>
					<div class="fields-container" *ngIf="orderHeaderVM.agencyContactId === '0'">
						<div class="field">
							<div class="data-panel-field-label">{{ "MY_ADS.LIST.CONTACT" | translate }}</div>
							<div class="data-panel-field-value">{{ orderHeaderVM?.contactFirstName + " " + orderHeaderVM?.contactLastName}}</div>
							<div class="data-panel-field-value contact-email" *ngIf="orderHeaderVM.contactEmail">
								<a class="branding--general--email-address" href="{{ 'mailto:' + orderHeaderVM.contactEmail }}"><span class="contact-email-icon">email</span> {{ orderHeaderVM.contactEmail }}</a>
							</div>
							<div class="data-panel-field-value contact-phone" *ngIf="orderHeaderVM.contactPhone">
								<p class="branding--general--phone"><span class="contact-phone-icon">phone</span> {{ orderHeaderVM.contactPhone }}</p>
							</div>
						</div>
					</div>
				</ng-template>
				<div class="fields-container">
					<div class="field">
						<div class="data-panel-field-label">{{ "MY_ADS.LIST.CAMPAIGN_NAME_TITLE" | translate }}</div>
						<div class="data-panel-field-value">{{ orderHeaderVM.campaignName }}</div>
					</div>
					<div class="field">
						<div class="data-panel-field-label">{{ "MY_ADS.LIST.NET_TITLE" | translate }}</div>
						<div class="data-panel-field-value">{{ orderHeaderVM.net | cassCurrency:orderHeaderVM.currencyCode }}</div>
					</div>
				</div>
				<div class="fields-container">
					<div class="field">
						<div class="data-panel-field-label">{{ "MY_ADS.LIST.PRODUCTS_TITLE" | translate }}</div>
						<div class="data-panel-field-value">{{ orderHeaderVM.products }}</div>
					</div>
					<div class="field">
						<div class="data-panel-field-label">{{ "MY_ADS.LIST.PLACEMENTS_TITLE" | translate }}</div>
						<div class="data-panel-field-value">{{ orderHeaderVM.placements }}</div>
					</div>
					<div class="field">
						<div class="data-panel-field-label">{{ "MY_ADS.LIST.SIZES_TITLE" | translate }}</div>
						<div class="data-panel-field-value">{{ orderHeaderVM.sizes }}</div>
					</div>
				</div>
				<div class="fields-container">
					<div class="field">
						<div class="data-panel-field-label">{{ "MY_ADS.LIST.FIRST_DATE_TITLE" | translate }}</div>
						<div class="data-panel-field-value">{{ orderHeaderVM.startDate | cassDate }}</div>
					</div>
					<div class="field">
						<div class="data-panel-field-label">{{ "MY_ADS.LIST.LAST_DATE_TITLE" | translate }}</div>
						<div class="data-panel-field-value">{{ orderHeaderVM.endDate | cassDate }}</div>
					</div>
					<div class="field">
						<div class="data-panel-field-label">{{ "MY_ADS.LIST.NEXT_DATE_TITLE" | translate }}</div>
						<div class="data-panel-field-value">{{ orderHeaderVM.nextDate | cassDate }}</div>
					</div>
					<div class="field">
						<div class="data-panel-field-label">{{ "MY_ADS.LIST.RUNS_BOOKED_TITLE" | translate }}</div>
						<div class="data-panel-field-value">{{ orderHeaderVM.adCount }} / {{ orderHeaderVM.adCountRemaining }}</div>
					</div>
				</div>
			</div>
		</div>
		<mat-action-row>
			<button mat-stroked-button (click)="openOrder(orderHeaderVM.id!)">
				{{ "MY_ADS.LIST.ACTION_BUTTON_LABELS.VIEW" | translate }}
			</button>
		</mat-action-row>
	</mat-expansion-panel>

	<mat-card class="no-items" *ngIf="displayNoAdsAlert">
		<mat-card-header>
			<mat-chip-set>
				<mat-basic-chip>{{ (displayMode === "showRecent" ? "MY_ADS.LIST.NO_RECENT_ADS_ALERT" : "MY_ADS.LIST.NO_ADS_ALERT") | translate }}</mat-basic-chip>
			</mat-chip-set>
		</mat-card-header>
	</mat-card>


</ng-container>
<ng-container *ngIf="!(callingOut$ | async); else loading">
</ng-container>
<ng-template #loading>
	<cass-indeterminate-circular-progress-indicator></cass-indeterminate-circular-progress-indicator>
</ng-template>
<ng-template #filterLoading>
	<div class="filter-loader">
		<cass-indeterminate-circular-progress-indicator></cass-indeterminate-circular-progress-indicator>
	</div>
</ng-template>
